class InformationLabel{
    static get(service) {
        if (service === 'system') {
            return 'label-operation';
        } else {
            return 'label-project';
        }
    }
}


export default InformationLabel;